var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 6.33301L0 13V15.667H25.333V13L12.667 6.33301ZM18.667 18.333V27.667H22.667V18.333H18.667ZM0 34.333H25.333V30.333H0V34.333ZM10.667 18.333V27.667H14.667V18.333H10.667ZM2.667 18.333V27.667H6.667V18.333H2.667Z",
    fill: "#3A3F60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 11.5C22.334 12.6162 22.5538 13.7215 22.981 14.7528C23.4082 15.7841 24.0343 16.7211 24.8236 17.5104C25.6129 18.2997 26.5499 18.9258 27.5812 19.353C28.6124 19.7801 29.7177 20 30.834 20C31.9502 20 33.0555 19.7801 34.0868 19.353C35.1181 18.9258 36.0551 18.2997 36.8444 17.5104C37.6337 16.7211 38.2598 15.7841 38.687 14.7528C39.1141 13.7215 39.334 12.6162 39.334 11.5C39.334 10.3838 39.1141 9.27846 38.687 8.24719C38.2598 7.21592 37.6337 6.27889 36.8444 5.48959C36.0551 4.70029 35.1181 4.07419 34.0868 3.64702C33.0555 3.21986 31.9502 3 30.834 3C29.7177 3 28.6124 3.21986 27.5812 3.64702C26.5499 4.07419 25.6129 4.70029 24.8236 5.48959C24.0343 6.27889 23.4082 7.21592 22.981 8.24719C22.5538 9.27846 22.334 10.3838 22.334 11.5Z",
    fill: "#77B05C",
    stroke: "#77B05C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1673 8.87574C33.0164 8.60086 32.797 8.37425 32.5328 8.22016C32.2686 8.06608 31.9694 7.99031 31.6673 8.00099H30.0007C29.5586 8.00099 29.1347 8.18531 28.8221 8.51341C28.5096 8.84151 28.334 9.2865 28.334 9.7505C28.334 10.2145 28.5096 10.6595 28.8221 10.9876C29.1347 11.3157 29.5586 11.5 30.0007 11.5H31.6673C32.1093 11.5 32.5333 11.6843 32.8458 12.0124C33.1584 12.3405 33.334 12.7855 33.334 13.2495C33.334 13.7135 33.1584 14.1585 32.8458 14.4866C32.5333 14.8147 32.1093 14.999 31.6673 14.999H30.0007C29.6986 15.0097 29.3994 14.9339 29.1352 14.7798C28.8709 14.6258 28.6516 14.3991 28.5007 14.1243",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6V17",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankMoney);
export default __webpack_public_path__ + "static/media/bank-money.bdb9d243.svg";
export { ForwardRef as ReactComponent };